import { render, staticRenderFns } from "./SentMessages.vue?vue&type=template&id=b6410570&scoped=true"
import script from "./SentMessages.vue?vue&type=script&lang=js"
export * from "./SentMessages.vue?vue&type=script&lang=js"
import style0 from "./SentMessages.vue?vue&type=style&index=0&id=b6410570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6410570",
  null
  
)

export default component.exports